module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#user",
      toString: function () {
        return this.url;
      }
    }